/* eslint-disable no-console */

// Utilities
import { warn } from 'vue'

export function consoleWarn(message: string): void {
  warn(`Untitle: ${message}`)
}

export function consoleError(message: string): void {
  warn(`Untitle error: ${message}`)
}

export function deprecate(original: string, replacement: string | string[]) {
  replacement = Array.isArray(replacement)
    ? replacement
        .slice(0, -1)
        .map((s) => `'${s}'`)
        .join(', ') + ` or '${replacement.at(-1)}'`
    : `'${replacement}'`
  warn(
    `[Untitle UPGRADE] '${original}' is deprecated, use ${replacement} instead.`
  )
}
